/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addSchoolAssignment } from '../fn/school/add-school-assignment';
import { AddSchoolAssignment$Params } from '../fn/school/add-school-assignment';
import { Assignment } from '../models/assignment';
import { AssignmentWithStudentIds } from '../models/assignment-with-student-ids';
import { createSchool } from '../fn/school/create-school';
import { CreateSchool$Params } from '../fn/school/create-school';
import { createSchoolClass } from '../fn/school/create-school-class';
import { CreateSchoolClass$Params } from '../fn/school/create-school-class';
import { createSchoolClasses } from '../fn/school/create-school-classes';
import { CreateSchoolClasses$Params } from '../fn/school/create-school-classes';
import { deleteSchool } from '../fn/school/delete-school';
import { DeleteSchool$Params } from '../fn/school/delete-school';
import { deleteSchoolClass } from '../fn/school/delete-school-class';
import { DeleteSchoolClass$Params } from '../fn/school/delete-school-class';
import { getAllStudentsInSchool } from '../fn/school/get-all-students-in-school';
import { GetAllStudentsInSchool$Params } from '../fn/school/get-all-students-in-school';
import { getAllTeachersInSchool } from '../fn/school/get-all-teachers-in-school';
import { GetAllTeachersInSchool$Params } from '../fn/school/get-all-teachers-in-school';
import { getSchool } from '../fn/school/get-school';
import { GetSchool$Params } from '../fn/school/get-school';
import { getSchoolAssignments } from '../fn/school/get-school-assignments';
import { GetSchoolAssignments$Params } from '../fn/school/get-school-assignments';
import { getSchoolClass } from '../fn/school/get-school-class';
import { GetSchoolClass$Params } from '../fn/school/get-school-class';
import { getSchoolClasses } from '../fn/school/get-school-classes';
import { GetSchoolClasses$Params } from '../fn/school/get-school-classes';
import { getSchools } from '../fn/school/get-schools';
import { GetSchools$Params } from '../fn/school/get-schools';
import { getStudentsInClass } from '../fn/school/get-students-in-class';
import { GetStudentsInClass$Params } from '../fn/school/get-students-in-class';
import { removeSchoolAssignment } from '../fn/school/remove-school-assignment';
import { RemoveSchoolAssignment$Params } from '../fn/school/remove-school-assignment';
import { School } from '../models/school';
import { SchoolClass } from '../models/school-class';
import { SchoolPagedData } from '../models/school-paged-data';
import { updateSchool } from '../fn/school/update-school';
import { UpdateSchool$Params } from '../fn/school/update-school';
import { updateSchoolClass } from '../fn/school/update-school-class';
import { UpdateSchoolClass$Params } from '../fn/school/update-school-class';
import { uploadSchoolAvatar } from '../fn/school/upload-school-avatar';
import { UploadSchoolAvatar$Params } from '../fn/school/upload-school-avatar';
import { uploadSchoolCoverPhoto } from '../fn/school/upload-school-cover-photo';
import { UploadSchoolCoverPhoto$Params } from '../fn/school/upload-school-cover-photo';

@Injectable({ providedIn: 'root' })
export class SchoolService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getSchools()` */
  static readonly GetSchoolsPath = '/school';

  /**
   * Gets all schools.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSchools()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSchools$Response(params?: GetSchools$Params, context?: HttpContext): Observable<StrictHttpResponse<SchoolPagedData>> {
    const obs = getSchools(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets all schools.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSchools$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSchools(params?: GetSchools$Params, context?: HttpContext): Observable<SchoolPagedData> {
    const resp = this.getSchools$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SchoolPagedData>): SchoolPagedData => r.body)
    );
  }

  /** Path part for operation `createSchool()` */
  static readonly CreateSchoolPath = '/school';

  /**
   * Creates a new school [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSchool()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createSchool$Response(params?: CreateSchool$Params, context?: HttpContext): Observable<StrictHttpResponse<School>> {
    const obs = createSchool(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Creates a new school [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSchool$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createSchool(params?: CreateSchool$Params, context?: HttpContext): Observable<School> {
    const resp = this.createSchool$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<School>): School => r.body)
    );
  }

  /** Path part for operation `getSchool()` */
  static readonly GetSchoolPath = '/school/{id}';

  /**
   * Gets the specified school.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSchool()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSchool$Response(params: GetSchool$Params, context?: HttpContext): Observable<StrictHttpResponse<School>> {
    const obs = getSchool(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets the specified school.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSchool$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSchool(params: GetSchool$Params, context?: HttpContext): Observable<School> {
    const resp = this.getSchool$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<School>): School => r.body)
    );
  }

  /** Path part for operation `updateSchool()` */
  static readonly UpdateSchoolPath = '/school/{id}';

  /**
   * Updates the specified school [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSchool()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateSchool$Response(params: UpdateSchool$Params, context?: HttpContext): Observable<StrictHttpResponse<School>> {
    const obs = updateSchool(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates the specified school [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSchool$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateSchool(params: UpdateSchool$Params, context?: HttpContext): Observable<School> {
    const resp = this.updateSchool$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<School>): School => r.body)
    );
  }

  /** Path part for operation `deleteSchool()` */
  static readonly DeleteSchoolPath = '/school/{id}';

  /**
   * Deletes the specified school [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteSchool()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSchool$Response(params: DeleteSchool$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteSchool(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Deletes the specified school [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteSchool$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSchool(params: DeleteSchool$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteSchool$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getAllStudentsInSchool()` */
  static readonly GetAllStudentsInSchoolPath = '/school/{schoolId}/students';

  /**
   * [policies: Teacher].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllStudentsInSchool()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllStudentsInSchool$Response(params: GetAllStudentsInSchool$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = getAllStudentsInSchool(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * [policies: Teacher].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllStudentsInSchool$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllStudentsInSchool(params: GetAllStudentsInSchool$Params, context?: HttpContext): Observable<void> {
    const resp = this.getAllStudentsInSchool$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getAllTeachersInSchool()` */
  static readonly GetAllTeachersInSchoolPath = '/school/{schoolId}/teachers';

  /**
   * [policies: Teacher].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllTeachersInSchool()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllTeachersInSchool$Response(params: GetAllTeachersInSchool$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = getAllTeachersInSchool(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * [policies: Teacher].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllTeachersInSchool$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllTeachersInSchool(params: GetAllTeachersInSchool$Params, context?: HttpContext): Observable<void> {
    const resp = this.getAllTeachersInSchool$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getSchoolAssignments()` */
  static readonly GetSchoolAssignmentsPath = '/school/{id}/assignments';

  /**
   * Gets all obligated school assignments for a school.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSchoolAssignments()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSchoolAssignments$Response(params: GetSchoolAssignments$Params, context?: HttpContext): Observable<StrictHttpResponse<(Assignment | AssignmentWithStudentIds)>> {
    const obs = getSchoolAssignments(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets all obligated school assignments for a school.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSchoolAssignments$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSchoolAssignments(params: GetSchoolAssignments$Params, context?: HttpContext): Observable<(Assignment | AssignmentWithStudentIds)> {
    const resp = this.getSchoolAssignments$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<(Assignment | AssignmentWithStudentIds)>): (Assignment | AssignmentWithStudentIds) => r.body)
    );
  }

  /** Path part for operation `addSchoolAssignment()` */
  static readonly AddSchoolAssignmentPath = '/school/{id}/assignments/{assignmentId}';

  /**
   * Adds an assignment to the school obligated assignments [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addSchoolAssignment()` instead.
   *
   * This method doesn't expect any request body.
   */
  addSchoolAssignment$Response(params: AddSchoolAssignment$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = addSchoolAssignment(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Adds an assignment to the school obligated assignments [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addSchoolAssignment$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  addSchoolAssignment(params: AddSchoolAssignment$Params, context?: HttpContext): Observable<void> {
    const resp = this.addSchoolAssignment$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `removeSchoolAssignment()` */
  static readonly RemoveSchoolAssignmentPath = '/school/{id}/assignments/{assignmentId}';

  /**
   * Removes an assignment from the school obligated assignments [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeSchoolAssignment()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeSchoolAssignment$Response(params: RemoveSchoolAssignment$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = removeSchoolAssignment(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Removes an assignment from the school obligated assignments [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeSchoolAssignment$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeSchoolAssignment(params: RemoveSchoolAssignment$Params, context?: HttpContext): Observable<void> {
    const resp = this.removeSchoolAssignment$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `uploadSchoolAvatar()` */
  static readonly UploadSchoolAvatarPath = '/school/{id}/avatar';

  /**
   * Saves the avatar image for the specified school [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadSchoolAvatar()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadSchoolAvatar$Response(params: UploadSchoolAvatar$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = uploadSchoolAvatar(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Saves the avatar image for the specified school [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `uploadSchoolAvatar$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadSchoolAvatar(params: UploadSchoolAvatar$Params, context?: HttpContext): Observable<void> {
    const resp = this.uploadSchoolAvatar$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `uploadSchoolCoverPhoto()` */
  static readonly UploadSchoolCoverPhotoPath = '/school/{id}/coverphoto';

  /**
   * Saves the cover photo image for the specified school [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadSchoolCoverPhoto()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadSchoolCoverPhoto$Response(params: UploadSchoolCoverPhoto$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = uploadSchoolCoverPhoto(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Saves the cover photo image for the specified school [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `uploadSchoolCoverPhoto$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadSchoolCoverPhoto(params: UploadSchoolCoverPhoto$Params, context?: HttpContext): Observable<void> {
    const resp = this.uploadSchoolCoverPhoto$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getSchoolClasses()` */
  static readonly GetSchoolClassesPath = '/school/{schoolId}/classes';

  /**
   * Gets all school class entries.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSchoolClasses()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSchoolClasses$Response(params: GetSchoolClasses$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SchoolClass>>> {
    const obs = getSchoolClasses(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets all school class entries.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSchoolClasses$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSchoolClasses(params: GetSchoolClasses$Params, context?: HttpContext): Observable<Array<SchoolClass>> {
    const resp = this.getSchoolClasses$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<SchoolClass>>): Array<SchoolClass> => r.body)
    );
  }

  /** Path part for operation `createSchoolClass()` */
  static readonly CreateSchoolClassPath = '/school/{schoolId}/classes';

  /**
   * Creates a new school class entry [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSchoolClass()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createSchoolClass$Response(params: CreateSchoolClass$Params, context?: HttpContext): Observable<StrictHttpResponse<SchoolClass>> {
    const obs = createSchoolClass(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Creates a new school class entry [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSchoolClass$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createSchoolClass(params: CreateSchoolClass$Params, context?: HttpContext): Observable<SchoolClass> {
    const resp = this.createSchoolClass$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SchoolClass>): SchoolClass => r.body)
    );
  }

  /** Path part for operation `getSchoolClass()` */
  static readonly GetSchoolClassPath = '/school/{schoolId}/classes/{id}';

  /**
   * Gets the specified school class entry [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSchoolClass()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSchoolClass$Response(params: GetSchoolClass$Params, context?: HttpContext): Observable<StrictHttpResponse<SchoolClass>> {
    const obs = getSchoolClass(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets the specified school class entry [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSchoolClass$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSchoolClass(params: GetSchoolClass$Params, context?: HttpContext): Observable<SchoolClass> {
    const resp = this.getSchoolClass$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SchoolClass>): SchoolClass => r.body)
    );
  }

  /** Path part for operation `updateSchoolClass()` */
  static readonly UpdateSchoolClassPath = '/school/{schoolId}/classes/{id}';

  /**
   * Updates the specified school class entry [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSchoolClass()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateSchoolClass$Response(params: UpdateSchoolClass$Params, context?: HttpContext): Observable<StrictHttpResponse<SchoolClass>> {
    const obs = updateSchoolClass(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates the specified school class entry [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSchoolClass$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateSchoolClass(params: UpdateSchoolClass$Params, context?: HttpContext): Observable<SchoolClass> {
    const resp = this.updateSchoolClass$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SchoolClass>): SchoolClass => r.body)
    );
  }

  /** Path part for operation `deleteSchoolClass()` */
  static readonly DeleteSchoolClassPath = '/school/{schoolId}/classes/{id}';

  /**
   * Deletes the specified school class entry [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteSchoolClass()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSchoolClass$Response(params: DeleteSchoolClass$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteSchoolClass(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Deletes the specified school class entry [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteSchoolClass$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSchoolClass(params: DeleteSchoolClass$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteSchoolClass$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getStudentsInClass()` */
  static readonly GetStudentsInClassPath = '/school/{schoolId}/classes/{id}/students';

  /**
   * Gets students in a class [policies: Teacher].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStudentsInClass()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStudentsInClass$Response(params: GetStudentsInClass$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = getStudentsInClass(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets students in a class [policies: Teacher].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStudentsInClass$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStudentsInClass(params: GetStudentsInClass$Params, context?: HttpContext): Observable<void> {
    const resp = this.getStudentsInClass$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createSchoolClasses()` */
  static readonly CreateSchoolClassesPath = '/school/{schoolId}/classes/csv';

  /**
   * Adds classes and students via CSV file [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSchoolClasses()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createSchoolClasses$Response(params: CreateSchoolClasses$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = createSchoolClasses(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Adds classes and students via CSV file [policies: GlobalAdmin].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSchoolClasses$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createSchoolClasses(params: CreateSchoolClasses$Params, context?: HttpContext): Observable<void> {
    const resp = this.createSchoolClasses$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
